document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('[data-section-id]');
  if (!section) return;

  const visitorSetting = section.getAttribute('data-visitor-setting');

  const visitKey = "site_first_visit";
  let isNewVisitor = false;

  if (!localStorage.getItem(visitKey)) {
    localStorage.setItem(visitKey, Date.now());
    isNewVisitor = true;
  } else {
    isNewVisitor = false;
  }

  console.log("🔹 Section setting selected:", visitorSetting);
  console.log("🔹 Detected user type:", isNewVisitor ? "New Visitor" : "Regular Visitor");

  if (visitorSetting === "disable") return;

  const FEATURED_KEY = "featuredCollectionShownAt";
  const now = Date.now();
  let savedTime = localStorage.getItem(FEATURED_KEY);

  if (!savedTime) {
    localStorage.setItem(FEATURED_KEY, now);
    savedTime = now;
  }

  const timeDiff = now - parseInt(savedTime, 10);

  // ----- REGULAR VISITOR SETTING -----
  if (visitorSetting === "regular") {
    if (isNewVisitor) {
      section.style.display = "none";
      return;
    }
    if (timeDiff > 300000) {
      section.style.display = "none";
      console.log("❌ Regular visitor section hidden after 5 minutes");
    } else {
      console.log("✅ Regular visitor within 5 minutes → section visible");
    }
    return;
  }

  // ----- NEW VISITOR SETTING -----
  if (visitorSetting === "new") {
    if (!isNewVisitor) {
      // 🔑 Pehle check karo ke 5 minute cross huay ya nahi
      if (timeDiff > 300000) {
        section.style.display = "none";
        console.log("❌ Regular visitor + New setting → hidden after 5 minutes");
        return;
      } else {
        console.log("✅ Regular visitor but within 5 minutes → section still visible");
      }
    }

    if (timeDiff > 300000) {
      section.style.display = "none";
      console.log("❌ Section hidden after 5 minutes (auto-hide)");
      return;
    }

    console.log("⏳ Section will auto-hide after 5 minutes");
    setTimeout(() => {
      section.style.display = "none";
      console.log("❌ Section hidden after 5 minutes");
    }, 5 * 60 * 1000);
  }
});
